import { render, staticRenderFns } from "./ClientesTable.vue?vue&type=template&id=4bac2b45&scoped=true&"
import script from "./ClientesTable.vue?vue&type=script&lang=js&"
export * from "./ClientesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac2b45",
  null
  
)

export default component.exports